module.exports = __webpack_public_path__ + "img/Girl_020033.6b59bbeb.png";